import { OneAnalyticsDashboardCategoryEnum } from 'generated/resources/graphql'
import { trainingsDashboardSpec } from './trainings'

/**
 * Default dashboard specs by category.
 * Each spec is used as the initial template when the user opens
 * a dashboard for the first time in that module.
 */
export const defaultDashboardSpecs: Partial<Record<OneAnalyticsDashboardCategoryEnum, object>> = {
  trainings: trainingsDashboardSpec,
}
